module.exports = __webpack_public_path__ + "img/site.e875c3d8.png";